import { useRef, useState } from "react";

import Modal from "shared/Components/modal";
import { MobilePaginationAlt } from "shared/Components/mobilePaginationAlt";
import Loader from "shared/Components/loader";
import { TrialDetailCard } from "./TrailDrawDetailCard";
import { globalVariables } from "helper/globalVariables";

export const TrailDrawListMobileTable = ({
  trailDraws,
  currentPage,
  totalPages,
  loading,
  error,
  handlePageChange,
}) => {
  const modalRef = useRef();
  const [selectedTrialIndex, setSelectedTrialIndex] = useState(null);

  const openModal = (e, trialIndex) => {
    e.stopPropagation();
    setSelectedTrialIndex(trialIndex);
    modalRef.current.openModal();
  };

  return (
    <>
      {!loading && !error ? (
        <>
          <div className="relative mb-2">
            <div className="flex h-14 border-b  border-gray-300">
              <div className="flex flex-1 items-center justify-center">
                <span>{globalVariables.memberName}</span>
              </div>
              <div className="flex flex-1 items-center justify-center">
                <span>{globalVariables.dogName}</span>
              </div>
            </div>

            {trailDraws?.length > 0 ? (
              trailDraws.map((trailDraw, index) => {
                return (
                  <div
                    className="flex h-20 border-b  border-gray-300"
                    onClick={(e) => openModal(e, index)}
                  >
                    <div className="flex flex-1 items-center justify-center">
                      <span>{trailDraw.memberName}</span>
                    </div>
                    <div className="flex flex-1 items-center justify-center">
                      <span>{trailDraw.dog}</span>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className="my-[50px] mx-[140px]">
                <span className="text-sm font-semibold">
                  {globalVariables.noRecord}
                </span>
              </div>
            )}
            {totalPages > 1 && (
              <MobilePaginationAlt
                currentPage={currentPage}
                totalPages={totalPages}
                handlePageChange={handlePageChange}
              />
            )}
          </div>
        </>
      ) : loading ? (
        <Loader stroke="text-gradient-500" />
      ) : (
        <span>{error?.message}</span>
      )}
      <Modal ref={modalRef}>
        {selectedTrialIndex !== null && (
          <TrialDetailCard trailDrawDetail={trailDraws[selectedTrialIndex]} />
        )}
      </Modal>
    </>
  );
};
